import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/sections/HeroSection';
import TrustBar from '../../components/feature/sections/TrustBar';
import ServicesOverview from '../../components/feature/sections/ServicesOverview';
import AIAnswerBlock from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import TestimonialsSection from '../../components/feature/sections/TestimonialsSection';
import FAQSection from '../../components/feature/sections/FAQSection';
import FinalCTASection from '../../components/feature/sections/FinalCTASection';

const trustItems = [
  { icon: 'ri-store-3-line', text: 'Premium Showroom & Warehouse', subtext: 'Brooklyn, NY' },
  { icon: 'ri-star-fill', text: '600+ Five-Star Reviews', subtext: 'Google & Yelp' },
  { icon: 'ri-hammer-line', text: 'Expert Installation Crews', subtext: 'Licensed & Insured' },
  { icon: 'ri-shield-star-line', text: 'Premium Material Brands', subtext: 'Shaw, Mohawk & More' },
  { icon: 'ri-map-pin-line', text: 'Serving All NYC Boroughs', subtext: 'Free In-Home Estimates' },
];

const services = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Carpet Installation',
    description: 'Wall-to-wall carpet in every style, pile height, and fiber — installed by our expert crews with precision and care for bedrooms, offices, and living spaces.',
    href: '/services',
    image: 'https://public.readdy.ai/ai/img_res/93c5039ce16df34901337865f461f1ad.jpg',
  },
  {
    icon: 'ri-artboard-line',
    title: 'Tile & Stone Flooring',
    description: 'Ceramic, porcelain, marble, travertine and natural stone flooring installed with precision. From kitchens to bathrooms and beyond.',
    href: '/services',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Luxury Vinyl Plank (LVP)',
    description: 'Waterproof, durable, and strikingly realistic — LVP delivers the look of hardwood or stone at exceptional value.',
    href: '/services',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Area Rugs',
    description: 'Curated selection of handmade, Oriental, Persian, and contemporary area rugs available in our Brooklyn showroom.',
    href: '/services',
  },
  {
    icon: 'ri-store-3-line',
    title: 'Showroom Consultation',
    description: 'Visit our Brooklyn showroom to explore hundreds of flooring samples. Our design consultants help you choose the perfect material for your space.',
    href: '/services',
  },
];

const aiColumns = [
  {
    heading: 'What We Do',
    paragraphs: [
      'Boro Rug & Flooring is Brooklyn\'s premier flooring showroom and installation company, serving NYC homeowners and businesses since 1998. We sell and install carpet, tile, stone, luxury vinyl plank, and area rugs — all backed by expert craftsmanship.',
      'Every project begins with a free in-home measurement and consultation, ensuring accurate estimates and a seamless installation experience from showroom to finished floor.',
    ],
  },
  {
    heading: 'Flooring Products We Offer',
    paragraphs: [
      'Our Brooklyn showroom carries hundreds of flooring options from leading brands including Shaw, Mohawk, Armstrong, and MSI Stone. We stock materials for every budget, style, and application.',
    ],
    bullets: [
      'Plush & berber carpet in all fiber types',
      'Ceramic, porcelain & natural stone tile',
      'Waterproof luxury vinyl plank (LVP)',
      'Handmade & machine-made area rugs',
      'Commercial-grade flooring solutions',
    ],
  },
  {
    heading: 'Professional Installation',
    paragraphs: [
      'Our licensed installation crews handle subfloor preparation, material removal, precision laying, and finishing. We work on residential and commercial projects of all sizes — delivering flawless results on time and on budget.',
    ],
  },
  {
    heading: 'The Showroom Advantage',
    paragraphs: [
      'Shopping flooring in person makes all the difference. Our 5,000 sq ft showroom lets you see, touch, and compare materials under real lighting — giving you confidence in your selection before a single board is laid.',
    ],
    bullets: [
      'Over 500 samples on display',
      'Expert design consultants on staff',
      'Take home samples for free',
      'Visualize materials in your home',
    ],
  },
];

const aiStats = [
  { value: '25+', label: 'Years serving Brooklyn & NYC' },
  { value: '5K+', label: 'Flooring projects completed' },
  { value: '600+', label: 'Five-star client reviews' },
  { value: '500+', label: 'Flooring samples in showroom' },
];

const processSteps = [
  { icon: 'ri-store-3-line', title: 'Visit Showroom', description: 'Explore our Brooklyn showroom with 500+ samples. Our consultants guide you to the best flooring for your space and budget.' },
  { icon: 'ri-palette-line', title: 'Product Selection', description: 'Choose from carpet, tile, LVP, stone, or area rugs. Take samples home to see how they look in your own lighting.' },
  { icon: 'ri-ruler-line', title: 'Measurement', description: 'Our team visits your home for precise measurement and a detailed, transparent quote — no surprises.' },
  { icon: 'ri-tools-line', title: 'Subfloor Prep', description: 'We handle removal of old flooring and prepare the subfloor to manufacturer standards before installation begins.' },
  { icon: 'ri-hammer-line', title: 'Installation', description: 'Expert crews install your flooring with precision, care, and clean job-site practices on every project.' },
  { icon: 'ri-checkbox-circle-line', title: 'Final Walkthrough', description: 'We do a complete walkthrough with you to ensure everything meets our high standards before we consider the job done.' },
];

const benefits = [
  { icon: 'ri-store-3-line', title: 'Showroom Experience', description: 'See and feel hundreds of flooring options in person at our 5,000 sq ft Brooklyn showroom. No online guessing.' },
  { icon: 'ri-hammer-line', title: 'Expert Installers', description: 'Licensed, insured installation crews with years of experience on residential and commercial flooring projects.' },
  { icon: 'ri-vip-diamond-line', title: 'Premium Material Brands', description: 'We partner with Shaw, Mohawk, Armstrong, MSI Stone, and more to bring you the finest flooring materials available.' },
  { icon: 'ri-map-pin-2-line', title: 'Local Brooklyn Reputation', description: 'Family-owned for 25+ years with deep roots in Brooklyn and hundreds of five-star reviews from local homeowners.' },
  { icon: 'ri-percent-line', title: 'Competitive Pricing', description: 'Showroom direct pricing with no middleman markup. Get premium flooring installed at fair, transparent prices.' },
];

const areas = [
  'Brooklyn', 'Park Slope', 'Brooklyn Heights', 'DUMBO', 'Williamsburg',
  'Flatbush', 'Crown Heights', 'Bushwick', 'Cobble Hill', 'Bay Ridge',
  'Bensonhurst', 'Manhattan', 'Queens', 'Staten Island', 'The Bronx',
  'Hoboken, NJ', 'Jersey City, NJ',
];

const testimonials = [
  {
    name: 'Michael R.',
    location: 'Park Slope, Brooklyn',
    rating: 5,
    text: 'We had our entire first floor done in LVP and the kitchen backsplash in marble tile. The installation crew was incredibly professional — they finished ahead of schedule and the results look absolutely stunning. We couldn\'t be happier with Boro Rug & Flooring.',
    service: 'LVP & Tile Installation',
  },
  {
    name: 'Amanda T.',
    location: 'Williamsburg, Brooklyn',
    rating: 5,
    text: 'The showroom experience was amazing. I had no idea what flooring I wanted, but after spending an hour with their consultant, I found the perfect carpet for my bedroom. The install was clean, fast, and the result is gorgeous.',
    service: 'Carpet Installation',
  },
  {
    name: 'Carlos M.',
    location: 'Crown Heights, Brooklyn',
    rating: 5,
    text: 'Used them to tile our bathroom and hallway with porcelain. The crew was skilled, respectful of our home, and the grout lines are perfectly even. Looks like a $20k job at a very reasonable price. Highly recommend!',
    service: 'Tile & Stone Flooring',
  },
  {
    name: 'Jennifer L.',
    location: 'Brooklyn Heights, Brooklyn',
    rating: 5,
    text: 'I visited the showroom after being frustrated with online flooring options. Within minutes I found a beautiful area rug that tied my living room together perfectly. The selection is incredible and the staff really know their products.',
    service: 'Area Rug Selection',
  },
  {
    name: 'Daniel W.',
    location: 'Bay Ridge, Brooklyn',
    rating: 5,
    text: 'They installed hardwood-look LVP throughout our entire apartment. The team was punctual, cleaned up after themselves, and the flooring looks incredible — all my guests think it\'s real hardwood. Great value, great service.',
    service: 'LVP Installation',
  },
];

const faqs = [
  {
    question: 'Who installs flooring near me in Brooklyn?',
    answer: 'Boro Rug & Flooring is Brooklyn\'s trusted flooring showroom and installation company, serving Park Slope, Williamsburg, Crown Heights, Bay Ridge, Flatbush, and all NYC boroughs. We provide free in-home estimates and professional installation for carpet, tile, LVP, and area rugs across Brooklyn and New York City.',
  },
  {
    question: 'How much does flooring installation cost in Brooklyn?',
    answer: 'Flooring installation costs in Brooklyn vary by material and room size. Carpet installation typically runs $3–$7 per sq ft installed. Tile and stone starts around $8–$15 per sq ft. Luxury vinyl plank runs $5–$10 per sq ft installed. Contact us for a free, no-obligation in-home estimate specific to your project.',
  },
  {
    question: 'What flooring is best for homes in Brooklyn?',
    answer: 'The best flooring depends on your lifestyle and space. Luxury vinyl plank is ideal for high-traffic areas and families with pets — it\'s waterproof and incredibly durable. Carpet adds warmth and comfort to bedrooms. Tile is perfect for kitchens and bathrooms. Our showroom consultants can help you choose the right material.',
  },
  {
    question: 'How long does flooring installation take?',
    answer: 'Most residential flooring projects in Brooklyn are completed in 1–3 days depending on the room size, material type, and whether subfloor preparation is needed. Large multi-room projects may take 3–5 days. We\'ll give you a precise timeline during your free in-home estimate.',
  },
  {
    question: 'Do you have a flooring showroom in Brooklyn?',
    answer: 'Yes! Our 5,000 sq ft showroom is located in Brooklyn at 1247 Flatbush Ave. We carry 500+ flooring samples including carpet, tile, natural stone, luxury vinyl plank, and area rugs from top brands like Shaw, Mohawk, Armstrong, and MSI Stone. Visit us Monday–Friday 9am–6pm or Saturday 10am–5pm.',
  },
  {
    question: 'Can you remove my old flooring before installing new?',
    answer: 'Absolutely. Boro Rug & Flooring provides full-service flooring replacement including removal and disposal of your existing floors and subfloor preparation. We handle everything so you don\'t have to coordinate multiple contractors — just one call for the complete job.',
  },
];

export default function HomePage() {
  return (
    <div className="bg-ivory">
      <Navbar />

      <HeroSection
        headline="Premium Flooring Showroom & Installation in Brooklyn, NY"
        subheadline="Carpet, tile, stone, vinyl, and area rugs — sold, designed, and installed by Brooklyn's most trusted flooring specialists since 1998."
        primaryCTA={{ label: 'Get Free Estimate', href: '/#quote' }}
        secondaryCTA={{ label: 'Visit Our Showroom', href: '/brooklyn' }}
        trustSignal="Trusted by 600+ Brooklyn homeowners"
        bgImage="https://readdy.ai/api/search-image?query=beautiful%20modern%20premium%20flooring%20showroom%20interior%20bright%20airy%20space%20with%20elegant%20light%20wood%20plank%20floors%20tile%20samples%20on%20display%20walls%20warm%20white%20lighting%20upscale%20retail%20interior%20design&width=1400&height=900&seq=hero-floor1&orientation=landscape"
        badge="Brooklyn's Flooring Showroom Since 1998"
        floatingBadgeTitle="5,000 sq ft Showroom"
        floatingBadgeText="500+ samples — carpet, tile, LVP & rugs"
      />

      <TrustBar items={trustItems} />

      <ServicesOverview
        title="Flooring Sales & Installation"
        subtitle="From our Brooklyn showroom to your finished floor — we handle every step of your flooring project."
        services={services}
        ctaLabel="Explore Service"
      />

      <AIAnswerBlock
        badge="Flooring Showroom & Installation"
        title="Brooklyn's Premier Flooring Showroom & Installation Company"
        headline="Boro Rug & Flooring has served Brooklyn homeowners and businesses since 1998, providing premium flooring products and expert installation."
        columns={aiColumns}
        stats={aiStats}
        sidebarTitle="Why Brooklyn Chooses Boro Rug"
      />

      <ProcessSection
        title="From Showroom to Finished Floor"
        subtitle="A streamlined process designed to make your flooring project smooth, transparent, and stress-free."
        steps={processSteps}
      />

      <WhyChooseUs
        title="Brooklyn's Most Trusted Flooring Specialists"
        subtitle="Over 25 years of premium flooring expertise, serving discerning homeowners and businesses across Brooklyn and New York City."
        benefits={benefits}
        image="https://readdy.ai/api/search-image?query=professional%20flooring%20installer%20laying%20luxury%20vinyl%20plank%20floor%20in%20bright%20modern%20home%20interior%20natural%20light%20clean%20beautiful%20contemporary%20living%20room%20installation%20craftsmanship&width=800&height=700&seq=why-floor1&orientation=portrait"
        image2="https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20beautiful%20natural%20stone%20tile%20floor%20installation%20perfect%20grout%20lines%20premium%20material%20high%20end%20residential%20interior&width=400&height=300&seq=why-floor2&orientation=landscape"
        ctaLabel="Get Free Estimate"
        badge="Why Choose Us"
        badgeTitle="25+ Years"
        badgeSubtext="In Brooklyn"
      />

      <ServiceAreas
        title="Serving Brooklyn & All NYC Boroughs"
        subtitle="In-home estimates and professional installation available throughout New York City."
        description="Boro Rug & Flooring proudly serves Brooklyn homeowners and businesses with premium flooring sales and expert installation. From Park Slope to Flatbush, Crown Heights to Bay Ridge — and across Manhattan, Queens, Staten Island, and the Bronx. Visit our showroom or request a free in-home estimate today."
        areas={areas}
      />

      <TestimonialsSection testimonials={testimonials} />

      <FAQSection
        title="Flooring Questions Answered"
        faqs={faqs}
      />

      <FinalCTASection
        headline="Transform Your Floors Today"
        subheadline="Visit our Brooklyn showroom or schedule a free in-home estimate. Brooklyn's most trusted flooring specialists are ready to help."
        bgImage="https://readdy.ai/api/search-image?query=stunning%20luxury%20home%20interior%20with%20beautiful%20herringbone%20wood%20look%20vinyl%20plank%20floor%20in%20bright%20modern%20living%20space%20elegant%20furniture%20warm%20ambient%20lighting%20premium%20residential%20flooring&width=1600&height=900&seq=cta-floor1&orientation=landscape"
        formAction="https://readdy.ai/api/form/d6umjl5t4s7j0tv5i6b0"
        checkItems={['Free in-home estimates', 'Professional installation', 'All NYC boroughs served']}
      />

      <Footer />
    </div>
  );
}
